import { useMemo } from 'react';

import { CONVERSION_MODE } from '@/constants';

import { actionPhrase, buildContext, buildSkipAllMessage } from './helpers';

const { skip, sync } = CONVERSION_MODE;

const useConversionPreview = ({
  mode,
  total,
  isComplete,
  wouldSkipAll,
  sourceIds = [],
  priorConversions,
}) => {
  return useMemo(() => {
    if (isComplete) return null;
    if (!priorConversions) return null;
    if (mode !== skip && mode !== sync) return null;

    const priorCount =
      sourceIds.length > 0
        ? sourceIds.filter((id) => priorConversions[id]).length
        : Object.keys(priorConversions).length;

    if (priorCount === 0) return null;

    if (wouldSkipAll) return buildSkipAllMessage(sourceIds, total);

    const context = buildContext(sourceIds, total, priorCount);

    const subject = priorCount === 1 ? 'It' : 'They';

    return `${context}. ${subject} ${actionPhrase(mode)}.`;
  }, [mode, total, sourceIds, isComplete, wouldSkipAll, priorConversions]);
};

export default useConversionPreview;
